import React from 'react';
import EmailTypePicker from 'Components/Modals/EmailTypePicker';
import ScheduleSendDatePicker from 'Components/Modals/ScheduleSendDatePicker';
import AccomplishmentsModal from 'Components/Modals/Accomplishments';
import KnockoutModal from 'Components/Modals/Investment';
import {
  dialogNameMap,
  useEmailTabContext,
} from 'Components/AdvisorApp/Viewport/MissionControl/Page/Versions/Default/Tabs/Email/EmailView/EmailTabContext';

export const Dialogs = () => {
  const {
    meetingResource,
    agendaResource,
    dialogName,
    onAccomplishmentModalClose,
    onModalClose,
    handleConfirmImmediateSend,
    handleConfirmScheduleSend,
    sendType,
    handleSubmitScheduleSend,
  } = useEmailTabContext();

  return (
    <>
      {dialogName === dialogNameMap.emailType ? (
        <EmailTypePicker
          isOpen
          closeModal={onModalClose}
          openModal={() => { throw new Error('Not implemented'); }}
          onSubmit={handleConfirmImmediateSend}
          onScheduleSendEmail={handleConfirmScheduleSend}
          meetingResource={meetingResource}
          sendType={sendType}
          meetingAgendaResource={agendaResource}
        />
      ) : null}
      {dialogName === dialogNameMap.scheduleSend ? (
        <ScheduleSendDatePicker
          isOpen
          closeModal={onModalClose}
          meetingAgendaResource={agendaResource}
          onSubmit={handleSubmitScheduleSend}
        />
      ) : null}
      {dialogName === dialogNameMap.accomplishments ? (
        <AccomplishmentsModal
          onClose={onAccomplishmentModalClose}
        />
      ) : null}
      {dialogName === dialogNameMap.investments ? (
        <KnockoutModal
          meetingResource={meetingResource}
          onClose={onModalClose}
        />
      ) : null}
    </>
  );
};
